import { axiosIntance } from '../../../config/ApiConfig';

export const TablesDao = {
  list: (
    accountId: string,
    page: number | string | null,
    limit: number | string | null,
    search: string | null
  ) => {
    let query = '';
    if (search) {
      query = `&filter=${search}`;
    }

    if (!page) {
      page = process.env.REACT_APP_LIST_PAGE_DEFAULT;
    }
    if (!limit) {
      limit = process.env.REACT_APP_LIST_ROW_DEFAULT;
    }
    return axiosIntance.get(
      `/tables?page=${page}&limit=${limit}&account=${accountId}${query}`
    );
  },
  show: (id: string) => {
    return axiosIntance.get(`/tables/${id}`);
  },
  getList: (accountId: string) => {
    return axiosIntance.get(`/tables/list?account=${accountId}`);
  },
  getListAllQR: (accountId: string) => {
    return axiosIntance.get(`/tables/list/qr?account=${accountId}`);
  },
  getAccountsList: (accountId: string) => {
    return axiosIntance.get(`/${accountId}/accounts/list`);
  },
};
